import React from "react";
import { useCart } from "../../context/CartContext";


export default function CartButtonAndPreview() {
  const { cartItems, total, removeFromCart, updateQty } = useCart();
  const [open, setOpen] = React.useState(false);
  const rootRef = React.useRef(null);

  const itemCount = cartItems.reduce((s, x) => s + Number(x.quantity || 0), 0);

  React.useEffect(() => {
    function onDoc(e) {
      if (rootRef.current && !rootRef.current.contains(e.target)) setOpen(false);
    }
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, []);

  return (
    <div ref={rootRef} className="relative z-99999999">
      <button
        onClick={() => setOpen((s) => !s)}
        className="transition-colors px-3 md:px-4 py-1 md:py-2 hover:opacity-70"
        aria-expanded={open}
      >
        CART ({itemCount})
      </button>

      {open && (
        <div className="absolute right-0 mt-2 w-[340px] bg-white border rounded-md shadow-lg z-50">
          <div className="p-3 max-h-[60vh] overflow-auto">
            {cartItems.length === 0 ? (
              <p className="text-sm text-gray-600">Empty</p>
            ) : (
              cartItems.map((it) => (
                <div key={it.key} className="flex items-center gap-3 py-2 border-b last:border-b-0">
                  <img
                    src={it.image || it.imageUrl || "/placeholder.png"}
                    alt={it.name}
                    className="w-12 h-12 object-cover rounded"
                  />
                  <div className="flex-1">
                    <div className="text-sm font-medium">{it.name}</div>
                    <div className="text-xs text-gray-500">
                      {it.color ? `${it.color}` : ""} {it.size ? ` • ${it.size}` : ""}
                    </div>

                    <div className="mt-1 flex items-center gap-2 text-black">
                      <button
                        onClick={() => updateQty(it.key, (Number(it.quantity) || 1) - 1)}
                        className="w-6 h-6 text-sm border rounded"
                        aria-label="decrease"
                      >
                        -
                      </button>

                      <div className="text-sm w-6 text-center">{it.quantity}</div>

                      <button
                        onClick={() => updateQty(it.key, (Number(it.quantity) || 1) + 1)}
                        className="w-6 h-6 text-sm border rounded"
                        aria-label="increase"
                      >
                        +
                      </button>

                      <div className="ml-3 text-sm font-semibold">
                        ${(Number(it.price) * Number(it.quantity || 1)).toFixed(2)}
                      </div>
                    </div>

                  </div>

                  <button
                    onClick={() => removeFromCart(it.key)}
                    className="text-xs text-red-500 hover:underline"
                    aria-label="Remove item"
                  >
                    Remove
                  </button>
                </div>
              ))
            )}
          </div>

          <div className="border-t p-3">
            <div className="flex justify-between items-center mb-2">
              <span className="font-medium">Total</span>
              <span className="font-semibold">${Number(total).toFixed(2)}</span>
            </div>

            <div className="flex gap-2">
              <a href="/cart" className="flex-1 text-center py-2 rounded-md border text-black">View cart</a>
              <a href="/checkout" className="flex-1 text-center py-2 rounded-md bg-black text-white">Checkout</a>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
